import { FormItem, Text } from '@billy/design-system'

import { InvoiceLineColumn } from '@features/invoices/types/invoiceLineColumn'

import { useInvoiceLineHeaderLabels } from '../../../../../../hooks/useInvoiceLineHeaderLabels'

interface InvoiceLineColumnHeaderProps {
  column: InvoiceLineColumn
}

export const InvoiceLinesHeaderColumn = ({ column }: InvoiceLineColumnHeaderProps) => {
  const { getHeaderLabel } = useInvoiceLineHeaderLabels()

  const headerAlignment = ['netTotal', 'total'].includes(column) ? 'right' : 'left'

  return (
    <FormItem>
      <Text variant="bodySM" weight="bold" alignment={headerAlignment}>
        {getHeaderLabel(column)}
      </Text>
    </FormItem>
  )
}
